module.exports = __webpack_public_path__ + "static/logo-134ec712e62b2becd55686e0af75e205.svg";